import { useGameStore } from '../store/gameStore';
import { useAuthStore } from '@/features/auth/store/authStore';
import { Card, CardContent } from '@/components/ui/card';

export const Scoreboard = () => {
  const { players } = useGameStore();
  const { user } = useAuthStore();

  const sortedPlayers = [...players].sort((a, b) => b.score - a.score);

  return (
    <Card>
      <CardContent className="p-4">
        <h3 className="text-lg font-semibold mb-4 text-primary">لوحة النتائج</h3>
        <div className="space-y-2">
          {sortedPlayers.map((player, index) => {
            const isMe = player.userId === user?.id;
            return (
              <div
                key={player.userId}
                className={`flex items-center justify-between p-2 rounded border ${
                  isMe ? 'bg-secondary/10 border-secondary' : 'bg-gray-50 border-gray-200'
                }`}
              >
                <div className="flex items-center gap-2">
                  <span className="text-sm font-bold text-gray-500">#{index + 1}</span>
                  <span className={isMe ? 'font-semibold text-secondary' : 'text-primary'}>{player.username}</span>
                  {isMe && <span className="text-xs text-secondary font-semibold">(أنت)</span>}
                </div>
                <span className="font-bold text-primary">{player.score} نقطة</span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
